import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import 'firebase/auth';
import 'firebase/firestore';
var firebaseConfig = {
    apiKey: "AIzaSyDjzjnv1X_dLwhMHq-JNrVFwwvbx0KJaOk",
    authDomain: "notes-ce39c.firebaseapp.com",
    databaseURL: "https://notes-ce39c-default-rtdb.firebaseio.com",
    projectId: "notes-ce39c",
    storageBucket: "notes-ce39c.appspot.com",
    messagingSenderId: "301954458458",
    appId: "1:301954458458:web:806e503e8fa17b70468963"
};
export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const provider = new GoogleAuthProvider();
export const db = getFirestore(app);
